

































import { Component, Vue } from "vue-property-decorator";
import { getCjScore } from "../api/cjScore";
@Component
export default class cjScore extends Vue {
  $route: any;
  $store: any;
  $router: any;
  $toast: any;
  reportId: any = "";
  cjData: any = {};
  cjScoreData: any = {};
  mounted() {
    this.cjData = this.$route.params.cjData;
    this.getCjScoreData();
  }
  goBack() {
    this.$router.go(-1);
  }
  getCjScoreData() {
    let params = {
      reportId: this.cjData.reportId, //this.cjData.reportId 1000731
    };
    getCjScore(params).then((res: any) => {
      if (res.data.data.length==0) {
        this.$toast.text("暂无拆解项评分，敬请期待");
      }
      this.cjScoreData = res.data;
    });
  }
}
